import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { Product } from '~app/modules/product/models';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { Category } from '~app/modules/generic/models';

export class AddToCartGa4ApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.AddToCartGa4;

  constructor(
    private product: Product,
    private offerId: string,
    private quantity: number,
    private priceType: PriceTypes,
    private breadcrumbs: Category[],
    private recommendation: boolean,
    private EECLabel: string,
    private isVasChecked: string,
    private previousUrl: string,
    private isBlackDealsEnabled: boolean,
    private searchTerm?: string,
    private itemListName?: string
  ) {}

  getPayload(): any {
    return {
      product: this.product,
      offerId: this.offerId,
      quantity: this.quantity,
      priceType: this.priceType,
      breadcrumbs: this.breadcrumbs,
      recommendation: this.recommendation,
      EECLabel: this.EECLabel,
      isVasChecked: this.isVasChecked,
      previousUrl: this.previousUrl,
      isBlackDealsEnabled: this.isBlackDealsEnabled,
      searchTerm: this.searchTerm,
      itemListName: this.itemListName,
    };
  }
}
